module.exports = __webpack_public_path__ + "img/l5.9e8a5c69.png";